export default __webpack_public_path__ + "static/media/1190.460962af.png";